import { useTranslation } from 'react-i18next';

import Language from 'classes/StandingData/Language/Language';

interface IProps {
	handleValueChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
	language: Language;
	selectedLanguage: string;
}

const LanguageLanguageInput = (props: IProps) => {
	const { t } = useTranslation();

	const renderContent = () => {
		return (
			<>
				<div className="row mt-2">
					<div className="col-12 mt-2">
						<div className="row mb-3">
							<label>{t('_general:DESCRIPTION')}</label>
							<div>
								<input
									value={
										props.language.nameTranslations[props.selectedLanguage] ||
										''
									}
									type="text"
									onChange={props.handleValueChange}
									className="form-control"
									name="descriptionTranslations"
									error-key={'DescriptionTranslations'}
								/>
							</div>
						</div>
					</div>
				</div>
			</>
		);
	};

	return <>{renderContent()}</>;
};

export default LanguageLanguageInput;
